// Inline SVG from the design pass (docs/design/index.html). Returned as
// strings for innerHTML on elements the app owns; no user content goes in.

export const ICON_BUTTERFLY = `<svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
<path fill="currentColor" d="M50 24 C45 12 30 4 18 8 C5 12 5 32 14 42 C22 51 40 52 50 44 C60 52 78 51 86 42 C95 32 95 12 82 8 C70 4 55 12 50 24 Z"></path>
<path fill="currentColor" d="M50 47 C42 44 26 46 20 56 C13 68 23 85 36 83 C46 81 48 66 50 60 C52 66 54 81 64 83 C77 85 87 68 80 56 C74 46 58 44 50 47 Z"></path>
<rect fill="currentColor" x="47" y="20" width="6" height="50" rx="3"></rect>
<path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" d="M48 22 C44 14 38 10 34 8 M52 22 C56 14 62 10 66 8"></path>
</svg>`;

export const ICON_GLOBE = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
<circle cx="12" cy="12" r="9"></circle>
<path d="M3 12h18M12 3c2.8 3 2.8 15 0 18M12 3c-2.8 3-2.8 15 0 18"></path>
</svg>`;

export const ICON_CAMERA = `<svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
<path d="M14 34h14l8-10h24l8 10h14v42H14z"></path>
<circle cx="48" cy="55" r="14"></circle>
</svg>`;

export const ICON_RETRY = `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
<path d="M20 12a8 8 0 1 1-2.6-5.9"></path>
<path d="M20 4v5h-5"></path>
</svg>`;
